// extracted by mini-css-extract-plugin
export var divider = "_tt-0";
export var systemMessage = "_tt-1";